import moment from "moment-timezone";
import { t } from "ttag";

export function formatDeviceDisconnectDate(
  disconnectedTimestamp: any,
  dateFormat: string,
  timeFormat: string
): string {
  if (disconnectedTimestamp && disconnectedTimestamp !== 0) {
    return moment(disconnectedTimestamp).format(`${dateFormat} ${timeFormat}`);
  }
  if (disconnectedTimestamp === 0) {
    return t`N/A`;
  }
  return "";
}

export function formatDeviceConnectDate(
  connectedTimestamp: any,
  dateFormat: string,
  timeFormat: string
): string {
  if (connectedTimestamp && connectedTimestamp !== 0) {
    return moment(connectedTimestamp).format(`${dateFormat} ${timeFormat}`);
  }
  return t`N/A`;
}

export function buildDeviceInformationValues(
  device: any,
  getDevicesTypesNames: (deviceType: any, type?: any) => string,
  dateFormat: string,
  timeFormat: string
) {
  return {
    serialNumber: device?.serial,
    deviceType: device?.deviceType
      ? getDevicesTypesNames(device.deviceType, device.type)
      : "CA Device",
    connectionStatus: device?.isConnected ? t`Connected` : t`Disconnected`,
    protocolVersion: device?.itcVersion ?? device?.protocolVersion,
    firmwareVersion: device?.firmwareVersion,
    buildDate: device?.buildDate,
    disconnectedTimestamp: formatDeviceDisconnectDate(
      device?.disconnectedTimestamp,
      dateFormat,
      timeFormat
    ),
    connectedTimestamp: formatDeviceConnectDate(
      device?.connectedTimestamp,
      dateFormat,
      timeFormat
    )
  };
}
